import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LoadingBuffer } from 'components/loading-buffer';
import { homePageRequestAction, homePageSelector } from 'pages/home.page';
import { navigationSelector } from 'common/selectors/navigation';
import { hasChannelPermission, isAdminUser } from 'utils';
import { ContentBox } from 'components/content-box';
import { useEffect } from 'react';

const hasHomePageLoaded = (props) => props.home.isLoaded > 0;

const HomePageLoaderComponent = (props) => {
  const isLoaded = props.home.isLoaded;
  const newProps = { ...props, statusCallback: hasHomePageLoaded };
  const isNotAdminAndNoPermissions = !hasChannelPermission() && !isAdminUser();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNotAdminAndNoPermissions) {
      return;
    }

    if (!isLoaded) {
      dispatch(homePageRequestAction());
    }
  }, [dispatch, isNotAdminAndNoPermissions, isLoaded]);

  return isNotAdminAndNoPermissions ? (
    <ContentBox>
      <div className="ct-error-404">
        <div className="row">
          <div className="col">
            <h1>{t('access_restriction')}</h1>
            <div className="permission-error-message">{t('restriction_content')}</div>
          </div>
        </div>
      </div>
    </ContentBox>
  ) : (
    <LoadingBuffer {...newProps} />
  );
};

export const HomePageLoader = connect((state) => ({
  home: homePageSelector(state),
  navigation: navigationSelector(state),
}))(HomePageLoaderComponent);
